import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { SocFormData } from 'components/Assessments/SocAssessment/types/SocFormData'
import { SocFormField } from 'components/Assessments/SocAssessment/types/SocFormField'
import { SocAssessmentQuestionnaireItem } from 'components/Assessments/SocAssessment/types/questionnaire'

/**
 * Lines/Drains subsection adapter
 * Handles lines and drains assessment (1 field - simplest subsection)
 */
export class LinesDrainsAdapter extends BaseSubsectionAdapter<SocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<SocFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Single field extraction
    const systemSummary = getAnswerValuesFromItems(
      flatAnswersArray,
      SocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_LINES_DRAINS_SYSTEM_SUMMARY
    )?.at(0)

    return {
      [SocFormField.LINES_DRAINS_SYSTEM_SUMMARY]: systemSummary
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    return [
      {
        linkId: SocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_LINES_DRAINS_SYSTEM_SUMMARY,
        value: this.getFormDataField(SocFormField.LINES_DRAINS_SYSTEM_SUMMARY)
      }
    ]
  }
}
